<script>
import { mapActions } from 'vuex';
import toggleModal from '@/mixins/toggleModal';

export default {
  props: {
    pageSize: {
      type: Number,
      required: true,
    },
    offset: {
      type: Number,
      required: true,
    },
    sortingParams: {
      type: Object,
      required: true,
    },
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      createClubCardAction: 'promotions/createForeverClubCard',
    }),
    handleOk(values) {
      this.createClubCardAction({
        value: {
          balance: String(values.balance),
        },
        limit: this.pageSize,
        offset: this.offset,
        sortingParams: this.sortingParams,
      });
      this.hideModal();
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="hideModal">
    <FormKit
      type="form"
      submit-label="Create"
      @submit="handleOk"
    >
      <h1 class="text-2xl font-bold mb-2">Create code for club card</h1>
      <FormKit
        type="number"
        number="integer"
        name="balance"
        label="Card's balance"
        placeholder="Enter balance"
        validation="required"
      />
    </FormKit>
  </a-modal>
</template>

<style scoped lang="scss">

</style>
